import * as fromDatatype from '../datatype-library';

export interface bl_wf_md_process_transition_to_transition_trigger_RowInterface {
  
  guid: fromDatatype.GuidDataFieldInterface;
  from_applet_guid: fromDatatype.GuidDataFieldInterface;
  from_comp_guid: fromDatatype.GuidDataFieldInterface;
  from_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  from_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  from_process_hdr_code: fromDatatype.VarcharDatatypeInterface;
  from_process_transition_guid: fromDatatype.GuidDataFieldInterface;
  from_process_transition_code: fromDatatype.VarcharDatatypeInterface;
  to_applet_guid: fromDatatype.GuidDataFieldInterface;
  to_server_doc_type: fromDatatype.VarcharDatatypeInterface;
  to_comp_guid: fromDatatype.GuidDataFieldInterface;
  to_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
  to_process_hdr_code: fromDatatype.VarcharDatatypeInterface;
  to_process_transition_guid: fromDatatype.GuidDataFieldInterface;
  to_process_transition_code: fromDatatype.VarcharDatatypeInterface;
  to_process_status_guid: fromDatatype.GuidDataFieldInterface;
  to_process_status_code: fromDatatype.VarcharDatatypeInterface;
  type: fromDatatype.VarcharDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
}

export class bl_wf_md_process_transition_to_transition_trigger_RowClass
  implements bl_wf_md_process_transition_to_transition_trigger_RowInterface {
    guid: fromDatatype.GuidDataFieldInterface;
    from_applet_guid: fromDatatype.GuidDataFieldInterface;
    from_comp_guid: fromDatatype.GuidDataFieldInterface;
    from_server_doc_type: fromDatatype.VarcharDatatypeInterface;;
    from_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    from_process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    from_process_transition_guid: fromDatatype.GuidDataFieldInterface;
    from_process_transition_code: fromDatatype.VarcharDatatypeInterface;
    to_applet_guid: fromDatatype.GuidDataFieldInterface;
    to_server_doc_type: fromDatatype.VarcharDatatypeInterface;
    to_comp_guid: fromDatatype.GuidDataFieldInterface;
    to_process_hdr_guid: fromDatatype.GuidDataFieldInterface;
    to_process_hdr_code: fromDatatype.VarcharDatatypeInterface;
    to_process_transition_guid: fromDatatype.GuidDataFieldInterface;
    to_process_transition_code: fromDatatype.VarcharDatatypeInterface;
    to_process_status_guid: fromDatatype.GuidDataFieldInterface;
    to_process_status_code: fromDatatype.VarcharDatatypeInterface;
    type: fromDatatype.VarcharDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
}
